export default __webpack_public_path__ + "static/media/black-belt.409bb631.png";